

















































































import { MainLayoutVueGB } from "@/extensions/layouts/MainLayoutVueGB";
import MainNavigation from "@/components/navigation/MainNavigation.vue";
import MainNavigationFooter from "@/components/navigation/MainNavigationFooter.vue";
import CommonFooter from "@/components/navigation/CommonFooter.vue";
import ServerCommandsController from "@/components/app/ServerCommandsController.vue";
import ContractsPanel from "@/components/contracts-panel/ContractsPanel.vue";
import { Component } from "vue-property-decorator";
import AppError from "@/components/app/AppError.vue";
import AuthCheck from "@/components/auth/AuthCheck.vue";
import ShortCodeSetModal from "@/components/settings/ShortCodeSetModal.vue";

@Component({
  components: { MainNavigation, CommonFooter, AppError, AuthCheck, ServerCommandsController, ContractsPanel, MainNavigationFooter, ShortCodeSetModal }
})
export default class MainLayout extends MainLayoutVueGB {
  safetyTipsModal: boolean = false;
  suggestShortCode: boolean = true;
  mounted() {
    this.suggestShortCode = this.isMobileBrowser && window.localStorage.getItem('dontSuggestToCreateShortCode') != "1" &&
     window.localStorage.getItem('loginWithoutPasswordOn') != "1";

    const modalShown = sessionStorage.getItem("modalShown");
    if (!modalShown) {
      this.safetyTipsModal = true;
      sessionStorage.setItem("modalShown", "1");
    }
  }

  get isMobileBrowser(): boolean {
    const userAgent = navigator.userAgent;
    const mobileRegExp = /Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i;
    return mobileRegExp.test(userAgent);
  }

  dontSuggestPinAction() {
    this.suggestShortCode = false;
    window.localStorage.setItem('dontSuggestToCreateShortCode', '1');
  }

  async created() {
    await this.init();
  }
  
  get windowWidthCalc(): number {
    return window.innerWidth;
  }

  beforeDestroy() {
    this.resetStoreStates();
  }
}
